<div class="content-body">
    <div class="row form-head mt-4 mx-1">
        <div>
            <a [routerLink]="['/invoices']" class="ac-goback-btn" >
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                    <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z"/>
                </svg>
                Go Back
            </a>
        </div>
    </div>
    <div class="container-fluid mt-4">
        <div class="row d-sm-flex d-block align-items-center mb-4">
            <div class="rowp d-block align-items-center mb-4 margin-0-mobile">
                <div class="me-auto d-sm-flex invoice-id-block" style="align-items: center;">
                    <h2 class="text-black font-w600 mb-0 ac-inv-no">Invoice: <span
                            class="font-w400 ps-2 pe-3">{{invoice.invoice_id}}</span></h2>

                    <a href="javascript:void(0)" class="badge {{invoice.status_class}} pt-1"
                        [style.backgroundColor]="invoice.statusColor"
                        [ngStyle]="{'color': (invoice.status === 'Not Paid') ? '#FA4628' : (invoice.status === 'Paid') ? '#028402' : (invoice.status === 'Partially Paid') ? '#fa783b' : ''}">{{invoice.status}}</a>
                </div>
                <div class="me-3 ac-phbtn-mob">
                    <h6 class="mobile-view heading-invoice-detail">Invoice Details</h6>
                    <a (click)="onDisputeInvoiceClick()" [state]="{'invoice':invoice,'type':'invoice'}"
                        class="btn ac-btn-primary  mb-sm-0 mb-2 me-2 float-left">
                        Dispute Invoice</a>
                    <!-- <a (click)="onDisputeInvoiceClick()" [state]="{'invoice':invoice,'item':item,'type':'item'}"
                        class="btn ac-btn-primary  mb-sm-0 mb-2 float-left" [class]="item != null && item.checked == true ? '':'disabled'">
                        Dispute Item</a> -->
            </div>
        </div>
        <div>
            <div class="col-lg-12 ac-inv-head">
                <h2 class="desktop-view">Invoice Details</h2>
                <p class="section-header" style="border-bottom:1px solid #d1d1d1;">Details</p>
                <div class="row d-flex justify-content-between mt-4 mb-3 invoice-details-section-1">
                    <div class="col-sm-12 col-md-3  ac-inner-head ac-inv-head">
                        <h6>Account No.</h6>
                        <p>{{invoice.bpNo}}</p>
                    </div>
                    <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
                        <h6>Invoice No.</h6>
                        <p>{{invoice.invoice_id}}</p>
                    </div>
                    <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
                        <h6>Bill Date</h6>
                        <p>{{invoice.date}}</p>
                    </div>
                    <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
                        <h6>Due Date</h6>
                        <p>{{invoice.dueDate}}</p>
                    </div>
                </div>
                <p class="section-header" style="border-bottom:1px solid #d1d1d1;">Address</p>
                <div class="row d-flex justify-content-between mt-4  mb-3 invoice-details-section-2">
                    <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
                        <h6>From</h6>
                        Brightspeed<br>
                        P.O. Box 2677<br>
                        Fayetteville, NC 28302-2677
                    </div>
                    <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head" style="text-transform: capitalize;">
                        <h6>To</h6>
                        {{invoice.businessPartnerName}}<br>
                        {{invoice.StreetName}}<br>
                        {{invoice.CityName}}, {{invoice.region}} {{invoice.zipCode}}
                    </div>
                    <div class="desktop-view col-sm-12 col-md-3"></div>
                    <div class="desktop-view col-sm-12 col-md-3"></div>
                </div>
                <div class="charge-actions">
                    <p class="section-header">Invoice Items</p>
                    <div (click)="downloadCSV()" class="download-button" tabindex="0" ngbTooltip="Download Charge Data as CSV" [ngClass]="{ 'disable': (invoiceItemData.length==0)}">
                        <svg class="me-2" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="40" id="download" viewBox="0 0 48 48">
                            <path d="M 23.970703 5.9726562 A 2.0002 2.0002 0 0 0 22 8 L 22 27.171875 L 19.414062 24.585938 A 2.0002 2.0002 0 1 0 16.585938 27.414062 L 22.585938 33.414062 A 2.0002 2.0002 0 0 0 25.414062 33.414062 L 31.414062 27.414062 A 2.0002 2.0002 0 1 0 28.585938 24.585938 L 26 27.171875 L 26 8 A 2.0002 2.0002 0 0 0 23.970703 5.9726562 z M 7.9707031 30.972656 A 2.0002 2.0002 0 0 0 6 33 L 6 36 C 6 39.290032 8.7099679 42 12 42 L 36 42 C 39.290032 42 42 39.290032 42 36 L 42 33 A 2.0002 2.0002 0 1 0 38 33 L 38 36 C 38 37.127968 37.127968 38 36 38 L 12 38 C 10.872032 38 10 37.127968 10 36 L 10 33 A 2.0002 2.0002 0 0 0 7.9707031 30.972656 z"></path>
                        </svg>
                    </div>
                </div>
                <div class="row d-block mb-2" style="text-align: -webkit-right;">
                    <div ngbDropdown class="mySelectArrow" >
                        <button class="btn btn-outline-secondary" id="dropdownDisputeType" ngbDropdownToggle>
                          {{ sellectedChargeType || 'All' }}
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownDisputeType">
                          <button ngbDropdownItem (click)="sellectedChargeType = 'All'"> {{ 'All' }} </button>
                          <button ngbDropdownItem *ngFor="let item of invoiceItemData | keyvalue; index as i" (click)="sellectedChargeType = item.key">
                            {{ item.key }}
                          </button>
                        </div>
                    </div>
                </div>
                <div class="d-sm-flex rowp d-block align-items-center mb-3 invoice-details-section-3"
                    style="color: white; background-color: black;padding: 10px;">
                    <div class="d-sm-flex col-5 ac-inner-head ac-inv-head"
                        style="align-items: center;display: -webkit-inline-box;">
                        <h6 class="summary-title">Current Charges Summary</h6>
                    </div>
                    <div class="me-3 col-5 ac-phbtn-mob ac-inner-head ac-inv-head service-info">
                        <h6>Service From {{invoice.date | date: 'MMM.dd,yyyy'}} To {{invoice.dueDate | date: 'MMM.dd,yyyy'}}</h6>
                    </div>
                </div>
                <div *ngIf="invoiceDetailsRecieved">
                    <div class="MonthlyCharges" *ngIf="invoiceItemData['Monthly Charges'] && (sellectedChargeType == 'All' || sellectedChargeType == 'Monthly Charges') ">
                        <div class="d-flex bg-light border ac-inner-head ac-inv-head">
                            <div class="col-7">
                                <div class="flex-fill font-w600 ac-inner-head ac-inv-head">
                                    <h6>Monthly Charges</h6>
                                </div>
                            </div>
                            <div class="col-5 d-flex justify-content-between">
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6>Qty</h6></div>
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6>Rate</h6></div>
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6>Amount</h6></div>
                            </div>
                        </div>
                        <div class="d-flex pl-3 border align-items-center" *ngFor="let item of invoiceItemData['Monthly Charges']">
                            <div class="col-7 d-flex">
                                <div class="flex-fill d-flex">
                                    <p class="p-0" style="margin-left: 24px;">
                                    <!-- <input type="radio" name="invoiceItem" [value]="item" style="accent-color: currentColor;" class="me-2" [checked]="item.checked" (click)="selectedItem(item)"> -->
                                    {{item.itemTypeName}}</p>
                                </div>
                            </div>
                            <div class="col-5 d-flex justify-content-between ac-inner-head ac-inv-head ">
                                <p>{{item.itemQuantity}}</p>
                                <p>{{item.rate  | number : '1.2-2'}}</p>
                                <p>${{item.itemCAAmountInTransactionCurrency  | number : '1.2-2'}}</p>
                            </div>
                        </div>
        
        
                        <div class="d-flex border">
        
                            <div class="col-2"></div>
                            <div class="col-10 d-flex justify-content-between  ">
                                <div class="mb-0 font-w600 ac-inner-head  ac-inv-head" ><p>Total Monthly Charges</p></div>
                                <div class="ms-auto font-w600 ac-inner-head  ac-inv-head"><p>${{totalCharges["Monthly Charges"] | number : '1.2-2'}}</p></div>
                            </div>
                        </div>
                    </div>

                    <div class="onetimeCharges" *ngIf="invoiceItemData['One Time Charges']  && (sellectedChargeType == 'All' || sellectedChargeType == 'One Time Charges')">
                        <div class="d-flex bg-light border ac-inner-head ac-inv-head">
                            <div class="col-7">
                                <div class="flex-fill font-w600 ac-inner-head ac-inv-head">
                                    <h6>One-Time Charges</h6>
                                </div>
                            </div>
                            <div class="col-5 d-flex justify-content-between">
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6></h6></div>
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6></h6></div>
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6></h6></div>
                            </div>
                        </div>
                        <div class="d-flex pl-3 border align-items-center" *ngFor="let item of invoiceItemData['One Time Charges']">
                            <div class="col-7 d-flex">
                                <div class="flex-fill d-flex">
                                    <p class="p-0" style="margin-left: 24px;">
                                    <!-- <input type="radio" name="invoiceItem" [value]="item" style="accent-color: currentColor;" class="me-2" [checked]="item.checked" (click)="selectedItem(item)"> -->
                                    {{item.itemTypeName}}</p>
                                </div>
        
                            </div>
                            <div class="col-5 d-flex justify-content-between ac-inner-head ac-inv-head ">
                                <p></p>
                                <p></p>
                                <p>${{item.itemCAAmountInTransactionCurrency  | number : '1.2-2'}}</p>
                            </div>
                        </div>
        
        
                        <div class="d-flex border">
        
                            <div class="col-2"></div>
                            <div class="col-10 d-flex justify-content-between  ">
                                <div class="mb-0 font-w600 ac-inner-head  ac-inv-head" ><p>Total One-Time Charges</p></div>
                                <div class="ms-auto font-w600 ac-inner-head  ac-inv-head"><p>${{totalCharges["One Time Charges"] | number : '1.2-2'}}</p></div>
                            </div>
                        </div>
                    </div>

                    <div class="adj" *ngIf="invoiceItemData['Adjustment'] && (sellectedChargeType == 'All' || sellectedChargeType == 'Adjustment')">
                        <div class="d-flex bg-light border ac-inner-head ac-inv-head">
                            <div class="col-7">
                                <div class="flex-fill font-w600 ac-inner-head ac-inv-head">
                                    <h6>Adjustments</h6>
                                </div>
                            </div>
                            <div class="col-5 d-flex justify-content-between">
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6></h6></div>
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6></h6></div>
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6></h6></div>
                            </div>
                        </div>
                        <div class="d-flex pl-3 border align-items-center" *ngFor="let item of invoiceItemData['Adjustment']">
                            <div class="col-7 d-flex">
                                <div class="flex-fill d-flex">
                                    <p class="p-0" style="margin-left: 24px;">
                                    <!-- <input type="radio" name="invoiceItem" [value]="item" style="accent-color: currentColor;" class="me-2" [checked]="item.checked" (click)="selectedItem(item)"> -->
                                    {{item.itemTypeName}}</p>
                                </div>
        
                            </div>
                            <div class="col-5 d-flex justify-content-between ac-inner-head ac-inv-head ">
                                <p></p>
                                <p></p>
                                <p>${{item.itemCAAmountInTransactionCurrency  | number : '1.2-2'}}</p>
                            </div>
                        </div>
        
        
                        <div class="d-flex border">
        
                            <div class="col-2"></div>
                            <div class="col-10 d-flex justify-content-between  ">
                                <div class="mb-0 font-w600 ac-inner-head  ac-inv-head" ><p>Total Adjustments</p></div>
                                <div class="ms-auto font-w600 ac-inner-head  ac-inv-head"><p>${{totalCharges["Adjustment"] | number : '1.2-2'}}</p></div>
                            </div>
                        </div>
                    </div>

                    <div class="Disc" *ngIf="invoiceItemData['DISCOUNTS'] && (sellectedChargeType == 'All' || sellectedChargeType == 'DISCOUNTS')">
                        <div class="d-flex bg-light border ac-inner-head ac-inv-head">
                            <div class="col-7">
                                <div class="flex-fill font-w600 ac-inner-head ac-inv-head">
                                    <h6>Discounts</h6>
                                </div>
                            </div>
                            <div class="col-5 d-flex justify-content-between">
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6></h6></div>
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6></h6></div>
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6></h6></div>
                            </div>
                        </div>
                        <div class="d-flex pl-3 border align-items-center" *ngFor="let item of invoiceItemData['DISCOUNTS']">
                            <div class="col-7 d-flex">
                                <div class="flex-fill d-flex">
                                    <p class="p-0" style="margin-left: 24px;">
                                    <!-- <input type="radio" name="invoiceItem" [value]="item" style="accent-color: currentColor;" class="me-2" [checked]="item.checked" (click)="selectedItem(item)"> -->
                                    {{item.itemTypeName}}</p>
                                </div>
        
                            </div>
                            <div class="col-5 d-flex justify-content-between ac-inner-head ac-inv-head ">
                                <p></p>
                                <p></p>
                                <p>${{item.itemCAAmountInTransactionCurrency  | number : '1.2-2'}}</p>
                            </div>
                        </div>
        
        
                        <div class="d-flex border">
        
                            <div class="col-2"></div>
                            <div class="col-10 d-flex justify-content-between  ">
                                <div class="mb-0 font-w600 ac-inner-head  ac-inv-head" ><p>Total DISCOUNTS</p></div>
                                <div class="ms-auto font-w600 ac-inner-head  ac-inv-head"><p>${{totalCharges["DISCOUNTS"] | number : '1.2-2'}}</p></div>
                            </div>
                        </div>
                    </div>

                    <div class="UC" *ngIf="invoiceItemData['Usage Charges'] && (sellectedChargeType == 'All' || sellectedChargeType == 'Usage Charges')">
                        <div class="d-flex bg-light border ac-inner-head ac-inv-head">
                            <div class="col-7">
                                <div class="flex-fill font-w600 ac-inner-head ac-inv-head">
                                    <h6>Usage Charges</h6>
                                </div>
                            </div>
                            <div class="col-5 d-flex justify-content-between">
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6></h6></div>
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6></h6></div>
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6></h6></div>
                            </div>
                        </div>
                        <div class="d-flex pl-3 border align-items-center" *ngFor="let item of invoiceItemData['Usage Charges']">
                            <div class="col-7 d-flex">
                                <div class="flex-fill d-flex">
                                    <p class="p-0" style="margin-left: 24px;">
                                    <!-- <input type="radio" name="invoiceItem" [value]="item" style="accent-color: currentColor;" class="me-2" [checked]="item.checked" (click)="selectedItem(item)"> -->
                                    {{item.itemTypeName}}</p>
                                </div>
        
                            </div>
                            <div class="col-5 d-flex justify-content-between ac-inner-head ac-inv-head ">
                                <p></p>
                                <p></p>
                                <p>${{item.itemCAAmountInTransactionCurrency  | number : '1.2-2'}}</p>
                            </div>
                        </div>
        
        
                        <div class="d-flex border">
        
                            <div class="col-2"></div>
                            <div class="col-10 d-flex justify-content-between  ">
                                <div class="mb-0 font-w600 ac-inner-head  ac-inv-head" ><p>Total Usage Charges</p></div>
                                <div class="ms-auto font-w600 ac-inner-head  ac-inv-head"><p>${{totalCharges["Usage Charges"] | number : '1.2-2'}}</p></div>
                            </div>
                        </div>
                    </div>

                    <div class="tax" *ngIf="invoiceItemData['TAX'] && (sellectedChargeType == 'All' || sellectedChargeType == 'TAX') ">
                        <div class="d-flex bg-light border ac-inner-head ac-inv-head">
                            <div class="col-7">
                                <div class="flex-fill font-w600 ac-inner-head ac-inv-head">
                                    <h6>Taxes, Fees and Surcharges</h6>
                                </div>
                            </div>
                            <div class="col-5 d-flex justify-content-between">
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6></h6></div>
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6></h6></div>
                                <div class="font-w600 ac-inner-head ac-inv-head"><h6></h6></div>
                            </div>
                        </div>
                        <div class="d-flex pl-3 border align-items-center" *ngFor="let item of invoiceItemData['TAX']">
                            <div class="col-7 d-flex">
                                <div class="flex-fill d-flex">
                                    <p class="p-0" style="margin-left: 24px;">
                                    <!-- <input type="radio" name="invoiceItem" [value]="item" style="accent-color: currentColor;" class="me-2" [checked]="item.checked" (click)="selectedItem(item)"> -->
                                    {{item.siteLocation}} - {{item.itemTypeName}}</p>
                                </div>
        
                            </div>
                            <div class="col-5 d-flex justify-content-between ac-inner-head ac-inv-head ">
                                <p></p>
                                <p></p>
                                <p>${{item.itemCAAmountInTransactionCurrency  | number : '1.2-2'}}</p>
                            </div>
                        </div>
        
        
                        <div class="d-flex border">
        
                            <div class="col-2"></div>
                            <div class="col-10 d-flex justify-content-between  ">
                                <div class="mb-0 font-w600 ac-inner-head  ac-inv-head" ><p>Total Taxes, Fees and Surcharges</p></div>
                                <div class="ms-auto font-w600 ac-inner-head  ac-inv-head"><p>${{totalCharges["TAX"] | number : '1.2-2'}}</p></div>
                            </div>
                        </div>
                    </div>
    
    
                    <div class="d-flex p-2 mt-4 ac-border mb-4" *ngIf="sellectedChargeType == 'All'">
                        <div class="col-12 d-flex justify-content-between ">
                            <div class="mb-0 font-w600 ac-inner-head  ac-inv-head"><p>Total Current Charges</p></div>
                            <div class="ms-auto font-w600 ac-inner-head  ac-inv-head"><p>${{totalCharges["Total"] | number : '1.2-2'}}</p></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #disputeStatus let-modal>
        <div class="modal-header" style="text-align: center;">
          <h5 class="modal-title">Permission Denied</h5>
        </div>
        <div class="modal-body text-center">
          <p>{{ disputeMeassage }}</p>
        </div>
        <div class="modal-footer ac-modelfooter mb-4">
          <button
            type="button"
            class="btn btn-primary ac-btn-primary"
            (click)="modal.dismiss('Cross click')"
            style="margin: 20px"
          >
            Close
          </button>
        </div>
      </ng-template>
</div>
